import { rootStore } from 'cv-react-core';

const getTheme = () => {
    const { themeStore } = rootStore;
    const theme = themeStore.getSanitizedTheme();

    // Populate the component parts with theme styles
    return {
        container: {
        },

        input: {
            ...theme.fonts.default,
        },

        adornmentButton: {
        },

        adornmentIcon: {
        },
    };
};

export default getTheme;
